import React, { useState, useEffect } from 'react';
//import { Container, Row, Col } from 'react-bootstrap';
import Lang from 'libraries/Lang';
import { getTopTrendsData } from 'libraries/trendsData';
import DestinationSectionLoader from './destinationSectionLoader';
import TopSunquestsDetailSection from './topSunquestsDetailSection';

const TopSunquests = (prop) => {
    const [topSunquests, setTopSunquests] = useState(false);
    const [topItems, setTopItems] = useState([]);
    const [activeTitle, setActiveTitle] = useState({"destinations" : "active", "hotels" : "", "durations" : ""});
    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getTopSunquestsPromise = getTopTrendsData('/api/trends/topSearchedSunquests', prop.env, prop.start, prop.end);

        getTopSunquestsPromise.then((result) => {
            setIsLoading(false);
            if (result) {
                if (result.isDataAvailable !== undefined && result.isDataAvailable == true) {
                    setTopSunquests(result);
                    setTopItems(result.destinations);
                    setIsDataAvailable(true);
                }
            }
        });
    }, []);

    const showSunquests = () => {
        setActiveTitle({"destinations" : "active", "hotels" : "", "durations" : ""});
        setTopItems(topSunquests.destinations);
    };

    const showHotels = () => {
        setActiveTitle({"destinations" : "", "hotels" : "active", "durations" : ""});
        setTopItems(topSunquests.hotels);
    };

    const showDurations = () => {
        setActiveTitle({"destinations" : "", "hotels" : "", "durations" : "active"});
        setTopItems(topSunquests.durations);
    };

    // 'https://www.redtag.ca/images/hotels/default.jpg';
    const defaultImage = 'https://travel-img-assets.s3.us-west-2.amazonaws.com/no-image/no-image-500x300.png';

    return (
        <>
            {isLoading == false ?   
            <>
                { isDataAvailable !== false ?       
                    <div class="p-5 mx-sm-5">
                        <div className="container mb-3 pb-1">
                            <h4 className="font-weight-bold">{Lang.trans('trends_top_suquests.title')}</h4>
                            <p className="font-sm font-weight-600 mb-0 text-black">{Lang.trans('trends_top_suquests.title_description')}</p>

                            <nav className="mt-3 text-left list-unstyled nav-tabs tabs-pill-bg d-inline-flex rounded-pill mb-4" role="tablist">
                                <li className="nav-item text-center">
                                    <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.destinations}`} id="destination" data-toggle="tab" role="tab" aria-controls="destination" aria-selected="true" onClick={showSunquests}>
                                        {Lang.trans('trends_top_suquests.destinations')}
                                    </a>
                                </li>
                                <li className="nav-item text-center">
                                    <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.hotels}`} id="hotel" data-toggle="tab" role="tab" aria-controls="hotel" aria-selected="true" onClick={showHotels}>
                                        {Lang.trans('trends_top_suquests.hotels')}
                                    </a>
                                </li>
                                <li className="nav-item text-center">
                                    <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.durations}`} id="duration" data-toggle="tab" role="tab" aria-controls="duration" aria-selected="true" onClick={showDurations}>
                                        {Lang.trans('trends_top_suquests.durations')}
                                    </a>
                                </li>
                            </nav>

                            
                            <div className="tab-content" id="topSunquest">
                                <div className="tab-pane fade show active" id="Sun" role="tabpanel" aria-labelledby="sub-tab">
                                    <div className="row mb-3 gutter-10">
                                        {activeTitle.destinations && activeTitle.destinations == 'active' && (
                                            <TopSunquestsDetailSection
                                                topSunquests={topSunquests}
                                                topItems={topItems}
                                            />
                                        )}
                                        {activeTitle.hotels && activeTitle.hotels == 'active' && (
                                            <TopSunquestsDetailSection
                                                topSunquests={topSunquests}
                                                topItems={topItems}
                                            />
                                        )}
                                        {activeTitle.durations && activeTitle.durations == 'active' && (
                                            <TopSunquestsDetailSection
                                                topSunquests={topSunquests}
                                                topItems={topItems}
                                            />
                                        )}
                                        {/* { topSunquests ?
                                            <>
                                                { topItems !== undefined && topItems !== null && topItems.length > 0 ?
                                                    <>
                                                        {topItems.map((item, key) => {
                                                            if(item.name != undefined ) {
                                                                return (
                                                                    <div className="col-6 col-sm-6 col-xl col-lg-4 col-md-4 mb-3 mb-xl-0">
                                                                        <div className="rounded-sm">
                                                                            <button className="btn-unstyled deal-list-card text-decoration-none">
                                                                                <div className="position-relative w-100 overflow-hidden">
                                                                                    <img className="w-100 object-fit-cover rounded-4" height="169" src={(item.image != undefined && item.image != '') ? item.image : defaultImage} data-was-processed="true" />
                                                                                    <div className="position-absolute left-bottom py-2 px-2 rounded-sm bg-black-transparent">
                                                                                        <h6 className="text-white text-center mb-0 font-size-md">
                                                                                            {(item.long != undefined && item.long != '') ? (item.name + ' in ' + item.long) : item.name}
                                                                                        </h6>
                                                                                    </div>
                                                                                </div>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }  
                                                        })}
                                                    </>
                                                :
                                                    null
                                                }
                                            </>
                                        : null } */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null }
            </>
            : <DestinationSectionLoader />}
        </>
    );
};

export default TopSunquests;
